import { Component, OnInit } from '@angular/core';
import { AdmissionWizardService } from '../../../services/wizard/admission/admission.wizzard.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admission-medical-order-scann-component',
  templateUrl: './admission-medical-order-scann.component.html',
  styleUrls: ['./admission-medical-order-scann.component.css']
})
export class AdmissionMedicalOrderScannComponent implements OnInit {
  medicalorderId: number;
  returnurl: string;
  protocol: string;
  medicalAppointmentId: number;

  constructor(private route: ActivatedRoute, private  router: Router) {
  }

 ngOnInit(): void {
  this.route.params.subscribe(async (params) => {
    this.medicalorderId =  params['MedicalOrderId'];
    this.returnurl = params['return'];
    this.protocol = params['Protocol'];
    this.medicalAppointmentId = params['MedicalAppointmentId'];
  });
 }

  finish(): void {
    this.router.navigate(['admission-operation', this.returnurl
    , this.medicalorderId
    , this.protocol
    , this.medicalAppointmentId ]);
  }
}
